import naja from "naja";
import Sortable from 'sortablejs';

// import { Tooltip } from 'bootstrap';

class BaseGridExtension {
    constructor() {
        // Persist column widths across snippet refreshes (keyed by table ID).
        // Without this, the CSS variable is lost when the table element is replaced by AJAX,
        // causing the column to re-measure its natural width (which can differ due to scrollbar).
        this.columnWidthMap = {};
    }

    initialize(naja) {
        window.addEventListener('DOMContentLoaded', () => this.init());
        naja.addEventListener('complete', () => this.init());
        naja.uiHandler.addEventListener('interaction', () => this.init());
        window.addEventListener('DOMContentLoaded', () => this.initFilterEnterSubmit());
        naja.addEventListener('complete', () => this.initFilterEnterSubmit());
    }

    init() {
        this.selects = $('input[type=checkbox].grid-line-select');
        this.buttons = $('.grid-line-select-button');
        this.conditionedButtons = $('.grid-line-select-button-conditioned');
        this.conditionedButtonsAsForm = $('.grid-line-select-button-conditioned-as-form');
        this.updateButtons();
        $(this.selects).each((index, element) => {
            $(element).closest('tr').on('click', (e) => {
                if (!$(e.target).is('input[type=checkbox]')) {
                    let input = $(e.target).closest('tr').find('input[type=checkbox].grid-line-select');
                    input.prop('checked', !input.prop('checked'));
                    this.updateButtons();
                }
            });

        });

        $(this.conditionedButtons).each((index, element) => {
            $(element).on('click', (e) => {
                const link = e.currentTarget.getAttribute('data-link');
                const storeId = $('#frm-tabs-tabContent-katalog-tabControl-filterForm-store').find(":selected").val();
                if ((typeof this.selectedValues === 'undefined' || this.selectedValues.length === 0) && !storeId) {
                    naja.makeRequest('GET', link);
                }
                else {
                    naja.makeRequest('POST', link, { values: this.selectedValues, storeId: storeId });
                }


            });
        });

        $(this.conditionedButtonsAsForm).each((index, element) => {
            $(element).on('click', (e) => {
                const link = e.currentTarget.getAttribute('data-link');
                const storeId = $('#frm-tabs-tabContent-katalog-tabControl-filterForm-store').find(":selected").val();
                if ((typeof this.selectedValues === 'undefined' || this.selectedValues.length === 0) && !storeId) {
                    // naja.makeRequest('GET', link);
                }
                else {
                    const form = $('<form action="' + link + '" method="post">' +
                        '<input type="hidden" name="values" value="' + this.selectedValues.join(',') + '" />' +
                        '<input type="hidden" name="storeId" value="' + storeId + '" />' +
                        '</form>');
                    $('body').append(form);
                    form.submit();
                }


            });
        });

        $(document).on('change', 'input[type=checkbox].grid-line-select', () => this.updateButtons())
            .on('change', 'th .select-all-checkbox-wrapper input[type=checkbox]', (e) => {
                this.selects.prop('checked', $(e.target).prop('checked'));
                this.updateButtons()
            })

        $(document).on('change', 'input[type=checkbox][data-check]', () => {
            this.updateGroupActionState();
        });

        $(document).on('change', 'select[name="group_action[group_action]"]', () => {
            this.updateGroupActionState();
        });

        $(document).on('mousedown', 'tr.row-dblclick-edit', function (e) {
            if (e.detail > 1) {
                e.preventDefault();
            }
        });

        $(document).on('dblclick', 'tr.row-dblclick-edit', function (e) {
            if ($(e.target).closest('a, button, input, select, textarea').length > 0) {
                return;
            }

            e.preventDefault();
            e.stopPropagation();

            const editUrl = $(this).data('dblclick-edit-url');
            if (editUrl) {
                const link = document.createElement('a');
                link.href = editUrl;
                link.className = 'ajax';

                link.click();
            }
        });

        this.initColumnResize();
        this.initLongTextTooltip();
    }

    initFilterEnterSubmit() {
        const inputs = document.querySelectorAll('input[data-datagrid-manualsubmit]');
        const selects = document.querySelectorAll('select[data-datagrid-manualsubmit]');

        inputs.forEach(input => {
            if (input.hasAttribute('data-enter-submit-initialized')) {
                return;
            }

            input.setAttribute('data-enter-submit-initialized', 'true');

            let lastVal = null;
            let isSubmitting = false; // Přidán flag pro prevenci duplicitních submitů

            input.addEventListener('change', () => {
                if (isSubmitting || lastVal === null || input.value === lastVal) {
                    lastVal = null;
                    return false;
                }

                isSubmitting = true;
                const form = input.closest('form');
                if (form.classList.contains('ajax')) {
                    console.log('form sub - change');
                    naja.uiHandler.submitForm(form).then(() => {
                        isSubmitting = false;
                    }).catch(() => {
                        isSubmitting = false;
                    });
                } else {
                    form.submit();
                }

                lastVal = null;
            });

            input.addEventListener('keydown', (event) => {
                if (event.key === 'Enter' || event.key === 'Tab') {
                    if (isSubmitting) {
                        event.preventDefault();
                        return false;
                    }

                    event.preventDefault();
                    event.stopPropagation();

                    isSubmitting = true;

                    const form = input.closest('form');

                    // Nejdřív blur, pak submit
                    input.blur();

                    // Malé zpoždění pro mobilní zařízení
                    setTimeout(() => {
                        if (form.classList.contains('ajax')) {
                            console.log('form sub - keydown');
                            naja.uiHandler.submitForm(form).then(() => {
                                setTimeout(() => {
                                    isSubmitting = false;
                                }, 500); // Delší timeout pro AJAX
                            }).catch(() => {
                                isSubmitting = false;
                            });
                        } else {
                            form.submit();
                        }
                    }, 100); // 100ms delay pro stabilitu na mobilu

                    lastVal = null;
                    return false;
                }

                lastVal = input.value;
            });

            if (input.hasAttribute('data-provide') && input.getAttribute('data-provide') === 'datepicker') {
                $(input).on('changeDate', () => {
                    if (isSubmitting) return;
                    isSubmitting = true;

                    const form = input.closest('form');
                    if (form.classList.contains('ajax')) {
                        console.log('datepicker changed - form sub');
                        naja.uiHandler.submitForm(form).then(() => {
                            isSubmitting = false;
                        }).catch(() => {
                            isSubmitting = false;
                        });
                    } else {
                        form.submit();
                    }
                });

                $(input).on('clearDate', () => {
                    if (isSubmitting) return;
                    isSubmitting = true;

                    console.log('clearDate');
                    const form = input.closest('form');
                    if (form.classList.contains('ajax')) {
                        console.log('datepicker cleared - form sub');
                        naja.uiHandler.submitForm(form).then(() => {
                            isSubmitting = false;
                        }).catch(() => {
                            isSubmitting = false;
                        });
                    } else {
                        form.submit();
                    }
                });
            }
        });

        selects.forEach(select => {
            if (select.hasAttribute('data-enter-submit-initialized')) {
                return;
            }

            select.setAttribute('data-enter-submit-initialized', 'true');

            let isSubmitting = false;

            select.addEventListener('change', () => {
                if (isSubmitting) return;
                isSubmitting = true;

                const form = select.closest('form');
                if (form.classList.contains('ajax')) {
                    console.log('select changed - form sub');
                    naja.uiHandler.submitForm(form).then(() => {
                        isSubmitting = false;
                    }).catch(() => {
                        isSubmitting = false;
                    });
                } else {
                    form.submit();
                }
            });
        });
    }
    updateGroupActionState() {
        const anyChecked = $('input[type=checkbox][data-check]:checked').length > 0;
        const selectedValue = $('select[name="group_action[group_action]"]').val();
        const hasSelectedOption = selectedValue !== '';

        $('select[name="group_action[group_action]"]').prop('disabled', !anyChecked);
        $('input[name="group_action[submit]"]').prop('disabled', !(anyChecked && hasSelectedOption));
    }

    updateButtons() {
        const selected = [];
        this.selects.filter(':checked').each((index, element) => {
            selected.push($(element).val());
        });
        this.selectedValues = selected;
        let id = this.selectedValues.join('_');

        this.buttons.each((index, button) => {
            const $button = $(button);
            let url = $button.attr('data-url');

            if (id && url) {
                url = url.replace(/id=\d+/, 'id=' + id);
                $button.attr('href', url);
            }

            $button.toggleClass('disabled', this.selectedValues.length <= 0);
        });
    }

    initColumnResize() {
        // Don't apply column resize inside iframes (e.g. selection dialogs)
        if (window.self !== window.top) return;

        // Arrow funkce kvůli `this` – s obyčejnou function tu `this` nebyla instance
        // třídy a init spadl hned na this.applyDefaultColumnWidths (TypeError
        // v konzoli při každém překreslení, resize sloupců se vůbec nenavázal).
        setTimeout(() => {
            const tables = document.querySelectorAll('.datagrid-wrapper[data-width-link] .table');
            tables.forEach(table => {
                if (table.classList.contains('resize-initialized')) return;

                // Skip tables inside Bootstrap modals
                if (table.closest('.modal')) return;

                const thead = table.querySelector('thead');
                if (!thead) return;

                const firstValidRow = [...thead.querySelectorAll('tr')]
                    .find(tr => !tr.classList.contains('row-group-actions'));

                const headers = firstValidRow ? firstValidRow.querySelectorAll('th') : [];
                if (!headers.length) return;

                // Apply saved widths first (while still in auto layout so offsetWidth is valid)
                this.applyDefaultColumnWidths(table);

                // Give the table a unique ID for scoped CSS
                if (!table.id) {
                    table.id = 'rz-' + Math.random().toString(36).substr(2, 9);
                }

                // Restore widths remembered from a previous render of this same table.
                // This survives AJAX snippet refreshes where the table element is replaced
                // but the table ID (from Nette's snippet naming) stays the same.
                const storedWidths = this.columnWidthMap[table.id] || {};

                // Build CSS rules that lock each column width via min-width + max-width.
                // Uses CSS variables so resizing only needs to update one variable.
                let css = '';
                headers.forEach(header => {
                    const colClass = Array.from(header.classList).find(cls => cls.startsWith('col-'));
                    if (!colClass) return;
                    // Priority: DB-saved inline style > JS in-memory cache > measured offsetWidth
                    const savedWidth = parseFloat(header.style.width) || storedWidths[colClass] || 0;
                    const width = savedWidth || Math.min(header.offsetWidth, 500);
                    storedWidths[colClass] = width;
                    table.style.setProperty(`--${colClass}-w`, `${width}px`);
                    css += `#${table.id} .${colClass} { width: var(--${colClass}-w) !important; min-width: var(--${colClass}-w) !important; max-width: var(--${colClass}-w) !important; }\n`;
                });

                this.columnWidthMap[table.id] = storedWidths;

                const styleEl = document.createElement('style');
                styleEl.textContent = css;
                document.head.appendChild(styleEl);

                // Override Bootstrap's width: 100% — table should be only as wide as its columns
                table.style.width = 'auto';
                table.classList.add('resize-initialized');

                headers.forEach(header => {
                    const resizer = document.createElement('div');
                    resizer.classList.add('resizer');
                    header.appendChild(resizer);

                    resizer.addEventListener('mousedown', (event) => this.toggleResize(header, event, table));
                });
            });
        }, 50)
    }

    toggleResize(header, event, table) {
        if (this.isResizing) {
            this.stopResize();
        } else {
            this.startResize(header, event, table);
        }
    }

    startResize(header, event, table) {
        this.isResizing = true;
        this.startX = event.clientX;
        this.resizeColClass = Array.from(header.classList).find(cls => cls.startsWith('col-'));
        this.startWidth = parseFloat(table.style.getPropertyValue(`--${this.resizeColClass}-w`)) || header.offsetWidth;

        this.resizeColumn = (event) => this.resizeColumnHandler(header, event, table);
        this.stopResize = (event) => this.stopResizeHandler(header, event, table);

        document.addEventListener('mousemove', this.resizeColumn);
        document.addEventListener('mouseup', this.stopResize);
    }

    resizeColumnHandler(header, event, table) {
        if (!this.isResizing) return;

        if (event instanceof MouseEvent) {
            const newWidth = Math.max(50, this.startWidth + (event.clientX - this.startX));
            table.style.setProperty(`--${this.resizeColClass}-w`, `${newWidth}px`);

            event.preventDefault();
        }
    }

    stopResizeHandler(header, event, table) {
        this.isResizing = false;
        document.removeEventListener('mousemove', this.resizeColumn);
        document.removeEventListener('mouseup', this.stopResize);

        if (event instanceof MouseEvent) {
            const newWidth = Math.max(50, this.startWidth + (event.clientX - this.startX));

            // Keep JS cache in sync with the user's drag so it survives snippet refreshes
            if (table.id) {
                if (!this.columnWidthMap[table.id]) this.columnWidthMap[table.id] = {};
                this.columnWidthMap[table.id][this.resizeColClass] = newWidth;
            }

            const columnClass = this.resizeColClass.replace('col-', '');
            naja.makeRequest('GET', table.closest('.datagrid-wrapper').dataset.widthLink, {
                column: columnClass,
                width: newWidth
            }, {
                history: false
            });
        }
    }

    applyDefaultColumnWidths(table) {
        const wrapper = table.closest('.datagrid-wrapper');
        if (!wrapper || !wrapper.getAttribute('data-width-default')) return;

        const defaultWidths = JSON.parse(wrapper.getAttribute('data-width-default'));

        const headers = table.querySelectorAll('th');
        headers.forEach(header => {
            const columnClass = Array.from(header.classList).find(cls => cls.startsWith('col-'))?.replace('col-', '');
            if (columnClass && defaultWidths[columnClass]) {
                header.style.width = `${defaultWidths[columnClass]}px`;
            }
        });
    }


    initLongTextTooltip() {
        document.querySelectorAll('.table tbody td:not(.col-select)').forEach(cell => {
            if (cell.querySelector('.btn')) return;
            if (cell.hasAttribute('data-no-tooltip') || cell.querySelector('[data-no-tooltip]')) return;
            // Tooltip už nastavený ze serveru (plný text) nepřepisovat zkráceným obsahem buňky
            if (cell.querySelector('[data-bs-toggle="tooltip"]')) return;

            const fullText = cell.textContent.trim();
            if (fullText.length > 35) {
                cell.setAttribute('data-bs-toggle', 'tooltip');
                cell.setAttribute('data-bs-placement', 'top');
                cell.setAttribute('title', fullText.replace(/\n/g, '<br>'));
            }
        });
    }
}

export default BaseGridExtension;
